import React, { FC, PropsWithChildren, ReactNode } from 'react';
import cx from 'classnames';
import XCircle from '@/assets/icons/xcircle.svg';
import * as styles from './Notice.module.scss';

export enum NoticeType {
  Error = 'error',
  Info = 'info',
}

type Props = PropsWithChildren<{
  type?: NoticeType;
  icon?: ReactNode;
}>;

const Notice: FC<Props> = ({ children, icon, type = NoticeType.Info }) => (
  <div
    role="alert"
    className={cx(styles.main, {
      [styles.error]: type === NoticeType.Error,
      [styles.info]: type === NoticeType.Info,
    })}
  >
    {type === NoticeType.Error ? <XCircle /> : null}
    <div className={styles.message}>
      {icon}
      {children}
    </div>
  </div>
);

export default Notice;
